<template>
  <div
    :class="{ 'show': isShow }"
    class="toast_box"
  >
    <div>{{message}}</div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data () {
    return {
      message: '',
      time: 3000,
      isShow: false
    }
  },
  methods: {
    show (message, time = 1000) {
      this.isShow = true
      this.message = message
      setTimeout(() => { this.isShow = false }, time)
    }
  }
}
</script>

<style>
  .toast_box {
    min-width: 130px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    text-align: center;
    border-radius: 30px;
    padding: 9px 22px;
    position: fixed;
    z-index: 10;
    left: 50%;
    bottom: 0;
    opacity: 0;
    transform: translateX(-50%);
    font-size: 16px;
    line-height: 24px;
    transition: all .5s ease;
  }

  .toast_box.show {
    bottom: 40px;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/Toast/Toast.vue